import React from "react";

const THRESHOLD_TYPE_OPTIONS = [
  { value: "", label: "Keine (deaktiviert)" },
  { value: "more_the_better", label: "Je mehr, desto besser" },
  { value: "less_the_better", label: "Je weniger, desto besser" },
  { value: "optimal_range", label: "Optimaler Bereich" },
];

/**
 * Simplified threshold/traffic-light settings section, ported from
 * AttributeSumLineChartSettings.jsx (without the cumulative "_per_day"
 * variant fields, which the delivery timeline tiles don't need).
 */
const ThresholdSettingsSection = ({
  thresholdType,
  onThresholdTypeChange,
  thresholdTarget,
  onThresholdTargetChange,
  thresholdWarningPercentage,
  onThresholdWarningPercentageChange,
  thresholdLower,
  onThresholdLowerChange,
  thresholdUpper,
  onThresholdUpperChange,
  loading = false,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-4">
      <label className="block text-sm font-medium text-gray-700">Schwellenwerte / Ampel-Farben</label>

      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Typ</label>
        <select
          value={thresholdType || ""}
          onChange={(e) => onThresholdTypeChange(e.target.value || null)}
          className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
          disabled={loading}
        >
          {THRESHOLD_TYPE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      {thresholdType && thresholdType !== "optimal_range" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Zielwert</label>
            <input
              type="number"
              value={thresholdTarget ?? ""}
              onChange={(e) => {
                const v = e.target.value;
                onThresholdTargetChange(v === "" ? null : Number(v));
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="z.B. 95"
              disabled={loading}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Warnschwelle (%)</label>
            <input
              type="number"
              value={thresholdWarningPercentage ?? ""}
              onChange={(e) => {
                const v = e.target.value;
                onThresholdWarningPercentageChange(v === "" ? null : Number(v));
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder={thresholdType === "more_the_better" ? "z.B. 80" : "z.B. 120"}
              disabled={loading}
            />
          </div>
        </div>
      )}

      {thresholdType === "optimal_range" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Untere Schwelle</label>
            <input
              type="number"
              value={thresholdLower ?? ""}
              onChange={(e) => {
                const v = e.target.value;
                onThresholdLowerChange(v === "" ? null : Number(v));
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="z.B. 0"
              disabled={loading}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Obere Schwelle</label>
            <input
              type="number"
              value={thresholdUpper ?? ""}
              onChange={(e) => {
                const v = e.target.value;
                onThresholdUpperChange(v === "" ? null : Number(v));
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
              placeholder="z.B. 3"
              disabled={loading}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ThresholdSettingsSection;
